const CalendarIcon = ({ fill = "#128370", ...props }) => (
  <svg width='13' height='12' viewBox='0 0 13 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_1767_19489)'>
      <path
        d='M11.2618 1.60882H9.01179V0.751674C9.01179 0.692746 8.96357 0.644531 8.90465 0.644531H8.15465C8.09572 0.644531 8.0475 0.692746 8.0475 0.751674V1.60882H4.61893V0.751674C4.61893 0.692746 4.57072 0.644531 4.51179 0.644531H3.76179C3.70286 0.644531 3.65465 0.692746 3.65465 0.751674V1.60882H1.40465C1.16759 1.60882 0.976074 1.80033 0.976074 2.03739V10.9302C0.976074 11.1673 1.16759 11.3588 1.40465 11.3588H11.2618C11.4988 11.3588 11.6904 11.1673 11.6904 10.9302V2.03739C11.6904 1.80033 11.4988 1.60882 11.2618 1.60882ZM10.7261 10.3945H1.94036V5.30525H10.7261V10.3945ZM1.94036 4.39453V2.5731H3.65465V3.21596C3.65465 3.27489 3.70286 3.3231 3.76179 3.3231H4.51179C4.57072 3.3231 4.61893 3.27489 4.61893 3.21596V2.5731H8.0475V3.21596C8.0475 3.27489 8.09572 3.3231 8.15465 3.3231H8.90465C8.96357 3.3231 9.01179 3.27489 9.01179 3.21596V2.5731H10.7261V4.39453H1.94036Z'
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id='clip0_1767_19489'>
        <rect width='12' height='12' fill='white' transform='translate(0.333008)' />
      </clipPath>
    </defs>
  </svg>
);

export default CalendarIcon;
